import { sfNames } from 'app/components/access-panel/sf-names';
import {
  serializeValue, serializeKeyAndValue, serializeExtraInfo, serializeDefaultValues, serializeValueOmitNotActive
} from 'app/components/access-panel';
import { AccessPanelData, ExtraInfoCodes, Person, User } from 'app/components/access-panel/shared/types';
import { PersonActionType } from 'app/area/administration/shared/types';
import { AdminInfoData } from 'app/types-shared';

export const serializeAccessData = (
  accessData: AccessPanelData,
  actionType: PersonActionType,
  extraInfoCodes: ExtraInfoCodes,
  originalData: Person,
  adminAcces: AdminInfoData) => {
  return {
    [sfNames.accessToUserGroups]: serializeValue(accessData.accessToUserGroups),
    [sfNames.personExcluded]: serializeValue(accessData.personExcluded),
    [sfNames.accessToAssignRoles]: serializeValue(accessData.accessToAssignRoles),
    [sfNames.accessToScreen]: serializeKeyAndValue(accessData.accessToScreen, 'application', 'domainNode'),
    [sfNames.extendedAccess]: serializeKeyAndValue(accessData.extendedAccess, 'application', 'unit'),
    [sfNames.accessOperations]: serializeKeyAndValue(accessData.accessOperations, 'application', 'operation'),
    [sfNames.responsibleForUnits]: serializeKeyAndValue(accessData.responsibleForUnits, 'application', 'unit'),
    [sfNames.restrictedAccess]: serializeRestrictedAccess(accessData, originalData, adminAcces),
    [sfNames.additionalInformation]: serializeExtraInfo(accessData.additionalInformation, actionType,
      extraInfoCodes, originalData?.additionalInformation),
    [sfNames.defaultValues]: serializeDefaultValues(accessData.defaultValues),
    [sfNames.experienceTransferAlerts]: serializeExperienceTransferAlerts(accessData, actionType, originalData, adminAcces)
  };
};

export const serializeTechnicalUser = (user: User) => user.technical && { technical: true };

const serializeRestrictedAccess = (accessData: AccessPanelData, originalData: Person,
  adminAcces: AdminInfoData) => !adminAcces.restrictedAccessPanel
    ? originalData?.restrictedAccess ?? []
    : serializeKeyAndValue(accessData.restrictedAccess, 'application', 'unit');

const serializeExperienceTransferAlerts = (accessData: AccessPanelData, actionType: PersonActionType, originalData: Person,
  adminAcces: AdminInfoData) => {
  if (!adminAcces.experienceTransferAlertsPanel) {
    return originalData?.experienceTransferAlerts ?? [];
  }

  if (actionType === PersonActionType.duplicate) {
    return serializeValueOmitNotActive(accessData.experienceTransferAlerts);
  }

  return serializeValue(accessData.experienceTransferAlerts);
};
